import {
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Form, Pagination, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { IoSearchSharp } from "react-icons/io5";

import { TbArrowDown, TbArrowUp, TbArrowsSort } from "react-icons/tb";

export default function CustomTable({
  data,
  columns,
  title,
  actionButton,
  footer,
}) {
  const { t } = useTranslation();
  const [sorting, setSorting] = useState([]);
  const [filtering, setFiltering] = useState("");
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    state: {
      sorting: sorting,
      globalFilter: filtering,
    },
    onSortingChange: setSorting,
    onGlobalFilterChange: setFiltering,
  });

  return (
    <Container fluid>
      <div className="d-flex flex-wrap align-items-center justify-content-between my-4">
        <div className="d-flex align-items-center justify-content-sm-between">
          <h5 className="font-weight-bold mr-3">{t(title)}</h5>
          <div>
            <select
              class="form-control form-control-sm"
              value={table.getState().pagination.pageSize}
              onChange={(e) => {
                table.setPageSize(Number(e.target.value));
              }}
            >
              {[5, 10, 20, 30, 40, 50].map((pageSize) => (
                <option key={pageSize} value={pageSize}>
                  {pageSize}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="create-workform">
          <div className="d-flex flex-wrap align-items-center justify-content-between">
            <div className="modal-product-search d-flex align-items-center">
              <Form className="mr-3 position-relative">
                <div className="form-group mb-0">
                  <Form.Control
                    type="text"
                    className="form-control"
                    value={filtering}
                    id="exampleInputText"
                    onChange={(e) => setFiltering(e.target.value)}
                    placeholder="Search ..."
                  />
                  <Link className="search-link" to="#">
                    <IoSearchSharp />
                  </Link>
                </div>
              </Form>

              <div className=" position-relative d-flex align-items-center justify-content-between">
                {actionButton}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="table-responsive">
        <table className="table data-table mb-0">
          <thead className="table-color-heading">
            {table.getHeaderGroups().map((headerGroup) => (
              <tr className="text-light" key={headerGroup.id}>
                <th>#</th>
                {headerGroup.headers.map((header) => (
                  <th
                    key={header.id}
                    onClick={header.column.getToggleSortingHandler()}
                    className="pointer-event"
                  >
                    {header.column.columnDef.id !== "NoneSortable" ? (
                      <div className="text-muted mb-0" role="button">
                        <span>
                          {flexRender(
                            t(header.column.columnDef.header),
                            header.getContext()
                          )}
                        </span>
                        <span className="ml-1 text-muted">
                          {header.column.getIsSorted() === "asc" ? (
                            <TbArrowUp />
                          ) : header.column.getIsSorted() === "desc" ? (
                            <TbArrowDown />
                          ) : (
                            <TbArrowsSort style={{ opacity: 0.4 }} />
                          )}
                        </span>
                      </div>
                    ) : null}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody>
            {table.getRowModel().rows.length === 0 ? (
              <tr>
                <td className="text-muted" colSpan={columns.length + 1}>
                  No records found
                </td>
              </tr>
            ) : (
              table.getRowModel().rows.map((row, rowIndex) => (
                <tr key={row.id} className="white-space-no-wrap">
                  <td>
                    {table.getState().pagination.pageSize *
                      table.getState().pagination.pageIndex +
                      rowIndex +
                      1}
                  </td>
                  {row.getVisibleCells().map((cell) => (
                    <td key={cell.id}>
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
          <tfoot>{footer}</tfoot>
        </table>
        {table.getPageCount() > 0 && (
          <Pagination className="justify-content-end">
            <Pagination.First onClick={() => table.setPageIndex(0)} />
            <Pagination.Prev
              disabled={!table.getCanPreviousPage()}
              onClick={() => table.previousPage()}
            />
            <Pagination.Item>
              {table.getState().pagination.pageIndex + 1} of{" "}
              {table.getPageCount()}
            </Pagination.Item>
            <Pagination.Next
              disabled={!table.getCanNextPage()}
              onClick={() => table.nextPage()}
            />
            <Pagination.Last
              onClick={() => table.setPageIndex(table.getPageCount() - 1)}
            />
          </Pagination>
        )}
      </div>
    </Container>
  );
}
